import React from "react";
import { CHECKOUT_FOOTER, CHECKOUT_STATE_CONFIG } from "../config/checkoutStateConfig";
import { CHECKOUT_THEME_VARS } from "../config/checkoutTheme";
import type { CheckoutViewState } from "../types/checkout";
import {
  buildEstiaAppLaunchUrl,
  isAndroidBrowser,
  isMobileBrowser,
} from "../services/openEstiaApp";
import PaymentStatusIcon from "./PaymentStatusIcon";

type Props = {
  state: CheckoutViewState;
  amountLabel: string;
  qrDataUrl: string;
  appLaunchUrl?: string;
  timeLabel: string;
  onClose: () => void;
  onRefreshQr: () => void;
};

const CheckoutCard: React.FC<Props> = ({
  state,
  amountLabel,
  qrDataUrl,
  appLaunchUrl,
  timeLabel,
  onClose,
  onRefreshQr,
}) => {
  const content = CHECKOUT_STATE_CONFIG[state];
  const stateClass = `ep-modal--${state.toLowerCase()}`;
  const isMobile = isMobileBrowser();
  const subtitle =
    isMobile && content.mobileSubtitle ? content.mobileSubtitle : content.subtitle;

  return (
    <section className={`ep-modal ${stateClass}`} style={CHECKOUT_THEME_VARS}>
      <button className="ep-closeBtn" onClick={onClose} aria-label="Close checkout">
        &#10005;
      </button>

      <div className="ep-main">
        {content.showQr && (
          <>
            <div className="ep-qrWrapper">
              <img src={qrDataUrl} alt="Payment QR code" className="ep-qrImage" />
              <div className="ep-qrCorners" />
            </div>
            <p className="ep-timer">{timeLabel} sec</p>
            {appLaunchUrl && isMobileBrowser() && (
              <a
                className="ep-openAppBtn"
                href={buildEstiaAppLaunchUrl(appLaunchUrl)}
                target={isAndroidBrowser() ? "_blank" : "_top"}
                rel="noopener"
              >
                On this phone? Open Estia app
              </a>
            )}
          </>
        )}

        {!content.showQr && (
          <>
            {state === "SUCCESS" && (
              <PaymentStatusIcon variant="success" className="ep-statusIconSvg" />
            )}
            {state === "FAILED" && (
              <PaymentStatusIcon variant="failed" className="ep-statusIconSvg" />
            )}
            {state !== "SUCCESS" && state !== "FAILED" && content.iconClassName && content.iconGlyph && (
              <div className={`ep-stateIcon ${content.iconClassName}`}>
                <span>{content.iconGlyph}</span>
              </div>
            )}
          </>
        )}

        <h1 className={`ep-title ${content.timeoutTitleSpacing ? "ep-title--timeout" : ""}`}>
          {content.title}
        </h1>

        <p className="ep-subtitle">{subtitle}</p>

        {content.showAmount && <p className="ep-amount">{amountLabel}</p>}

        {content.actionLabel && (
          <button className="ep-linkBtn" onClick={onRefreshQr}>
            {content.actionLabel}
          </button>
        )}
      </div>

      <footer className="ep-footer">
        {CHECKOUT_FOOTER.copyright}{" "}
        <a href="#" onClick={(e) => e.preventDefault()}>
          {CHECKOUT_FOOTER.privacyLabel}
        </a>
      </footer>
    </section>
  );
};

export default CheckoutCard;
